import { useSession } from '@supabase/auth-helpers-react';
import { useQuery } from '@tanstack/react-query';
import { getFullUserProfile } from '../api/supabaseAPI';

const useUser = () => {
  const session = useSession();
  const userId = session?.user?.id;
  return useQuery({
    queryKey: ['user', userId],
    queryFn: () => getFullUserProfile(userId),
    enabled: !!userId,
    staleTime: 1000 * 60 * 5,
  });
};

export default useUser;
